import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _styled from "styled-components";
var _excluded = ["show", "close", "children"],
    _excluded2 = ["event", "direction"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import { createUseGesture, dragAction, pinchAction } from '@use-gesture/react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Drawer = function Drawer(_ref) {
  var show = _ref.show,
      close = _ref.close,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var useGesture = createUseGesture([dragAction, pinchAction]);

  var _useSpring = useSpring(function () {
    return {
      x: 0,
      y: 0
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      y = _useSpring2[0].y,
      api = _useSpring2[1];

  var bind = useGesture({
    onDrag: function onDrag(_ref2) {
      var down = _ref2.down,
          _ref2$movement = _slicedToArray(_ref2.movement, 2),
          mx = _ref2$movement[0],
          my = _ref2$movement[1];

      return api.start({
        x: down ? mx : 0,
        y: down ? my : 0,
        immediate: down
      });
    },
    onDragEnd: function onDragEnd(_ref3) {
      var event = _ref3.event,
          _ref3$direction = _slicedToArray(_ref3.direction, 2),
          down = _ref3$direction[1],
          rest = _objectWithoutProperties(_ref3, _excluded2);

      event.preventDefault();
      if (down === -1) close();
    }
  }, {
    drag: {
      rubberband: true
    }
  });
  return /*#__PURE__*/_jsxs(animated.div, _objectSpread(_objectSpread(_objectSpread({}, bind()), {}, {
    style: {
      y: y
    }
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx(_StyledDiv, {
      children: /*#__PURE__*/_jsx(_StyledDiv2, {})
    }), children]
  }));
};
export default Drawer;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "drawer___StyledDiv",
  componentId: "sc-1cgown9-0"
})({
  "display": "flex",
  "minHeight": "2rem",
  "width": "100%",
  "touchAction": "none",
  "justifyContent": "center"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "drawer___StyledDiv2",
  componentId: "sc-1cgown9-1"
})({
  "marginBottom": "1rem",
  "width": "2.5rem",
  "alignSelf": "center",
  "borderRadius": "0.25rem",
  "borderWidth": "2px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))"
});